import { z } from 'zod';
export const loginRequestSchema = z.object({
    email: z.string().trim().toLowerCase().pipe(z.email()),
    password: z.string().min(1, 'Password is required.'),
});
export const sessionUserSchema = z.object({
    id: z.string(),
    email: z.string(),
    displayName: z.string(),
    lastLoginAt: z.string().nullable(),
});
export const PASSWORD_MIN_LENGTH = 12;
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN_LENGTH, `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`)
    .max(256);
//# sourceMappingURL=auth.js.map